import React from "react";

import RecorderService from "./RecorderService";

class AudioRecorder extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    console.log("AudioRecorder constructor");
    this.state = {
      audioSrc: null,
      audioType: '',
      //audioOutput: null // for returning blob
      //isRecording: false,
      //recording_status: props.recording_status
    };
    this.recording_status = props.recording_status;
    this.isRecording = false;
    //this.audioSrc = null; // local in-browser blob URL
    //this.audioType = '';
    this.recorderSrvc = null;
    
  }

  componentWillUnmount() {
    this._isMounted = false;
    console.log("AudioRecorder componentWillUnmount");
    // disconnect things!
    this.setState({ audioSrc: null, audioOutput: null });
    //this.handleStopRecording();
    if (this.recorderSrvc) {
      this.recorderSrvc.stopRecording();
    }
    this.recorderSrvc = null;
  }
  
  
  // componentWillMount() {
  //   console.log("componentWillMount");
  // }
  
  componentDidMount() {
    this._isMounted = true;
  }
  
  
  componentDidUpdate() {
    //console.log("componentDidUpdate",this.recording_status,this.props.recording_status);
    if (this.recording_status !== this.props.recording_status) {
      this.changeRecordingStatus(this.recording_status,this.props.recording_status);
    }    
  }
  
  changeRecordingStatus(prev_recording_status,new_recording_status) {
    console.log("changeRecordingStatus",prev_recording_status,new_recording_status);
    if (prev_recording_status === null && new_recording_status === 'recording') {
      // start
      this.handleStartRecording();
    } else if (prev_recording_status === 'recording' && new_recording_status === 'paused') {
      this.handlePauseRecording();
    } else if (prev_recording_status === 'paused' && new_recording_status === 'recording') {
      this.handleUnpauseRecording();
    } else if (prev_recording_status === 'inactive' && new_recording_status === 'recording') {
      // this is a restart
      this.setState({ audioSrc: null, audioOutput: null });
      this.recorderSrvc = null;
      this.handleStartRecording();
    } else if (new_recording_status === 'inactive') {
      // was either paused or recording
      this.handleStopRecording();
    }
    this.recording_status = new_recording_status;

  }
  
  async handleStartRecording () {
    console.log("handleStartRecording");
    if (!this.recorderSrvc) {
      console.log("Creating new RecorderService");
      this.recorderSrvc = new RecorderService();
      this.recorderSrvc.em.addEventListener('recording', (evt) => this._onNewRecording(evt));
    }
    //this.recorderSrvc = new RecorderService();
    let success = await this.recorderSrvc.startRecording();
    if (success === false) {
      this.recorderSrvc.cleanupThings();
      this.recording_status = null;
      this.props.failureCallback();
    } else {
      console.log("handleStartRecording STARTED");
      this.isRecording = true;
      this.props.startCallback();
    }
    //this.setState({ isRecording: true });
  }
  
  async handlePauseRecording() {
    console.log("handlePauseRecording");
    await this.recorderSrvc.pauseRecording();
    this.isRecording = false;
    this.props.pauseCallback();
    //this.setState({ isRecording: false });
  }
  
  async handleUnpauseRecording() {
    console.log("handleUnpauseRecording");
    await this.recorderSrvc.unpauseRecording();
    this.isRecording = true;
    this.props.unpauseCallback();
    //this.setState({ isRecording: true });
  }
  
  handleStopRecording() {
    console.log("handleStopRecording");
    if (this.recorderSrvc) {
      this.recorderSrvc.stopRecording();
    }
    this.isRecording = false;
    this.props.stopCallback();
    //this.props.stopCallback(); // stopCallback is called when _onNewRecording is hit
    //this.setState({ isRecording: false });
  }

  _onNewRecording (evt) {
    console.log("_onNewRecording",evt);

    // trying to handle unmount cleanup better
    if (this.recorderSrvc) {
      this.setState({
        audioSrc: evt.detail.recording.blobUrl,
        audioType: evt.detail.recording.mimeType,
        //audioOutput: evt.detail.recording.blob
      });
      this.props.finishCallback(evt.detail.recording.blob,evt.detail.recording.blobUrl,evt.detail.recording.mimeType);
    } else {
      // no nothing...we are in cleanup mode
    }
      
    //this.audioSrc = evt.detail.recording.blobUrl
    //this.audioType = evt.detail.recording.mimeType
    
    /*
    if (!this.saveNextRecording) {
      return
    }
    const newIdx = this.recordingsCont.childNodes.length + 1

    const newEl = document.createElement('div')
    newEl.innerHTML = '<audio id="audio-recording-' + newIdx + '" controls></audio>'
    this.recordingsCont.appendChild(newEl)

    const recordingEl = document.getElementById("audio-recording-" + newIdx);
    recordingEl.src = evt.detail.recording.blobUrl
    recordingEl.type = evt.detail.recording.mimeType
    */
  }
  
  render() {
    //console.log("render",this.state,this.props,this.isRecording,this.recording_status);
    let audio_element = null;
    if (this.state.audioSrc) {
      audio_element = React.createElement("audio", {
        style: {width: "100%"},
        controls: true,
        src: this.state.audioSrc,
        type: this.state.audioType,
        onSeeked: this.props.audioSeekCallback(),
        onPause: this.props.audioPauseCallback(),
        onPlay: this.props.audioStartCallback(),
        ref: this.props.audioRef
      });
      
      /*
        // JBB - this takes some hacking to get the duration
        if (isNaN(this.props.audioRef.current.duration) || this.props.audioRef.current.duration === Infinity) {
          this.props.audioRef.current.onloadedmetadata = (async () => {
            this.props.audioRef.current.currentTime = 1000000;
            this.props.audioRef.current.ontimeupdate = (async () => {
              this.props.audioRef.current.ontimeupdate = null;
              console.log("Retrieved audio duration",this.props.audioRef.current.duration)
              this.props.audioRef.current.currentTime = 0;
            });
          });
        } else {
          this.recorded_video_ref.current.currentTime = 0;
        }
      */

    }
    return (
      <div>
      <span>{this.props.slide_indicator}<br/></span>
      {audio_element}
      </div>
    );
  }
}
      /*
      <div>
        AudioRecorder Start<br/>
        isRecording: {this.isRecording}<br/>
        recording_status: {this.recording_status}<br/>
        AudioRecorder End<br/>
        {audio_element}
      </div>
      */

export default AudioRecorder;
/*
"use strict";

class App {
  constructor () {
    this.btnRecord = document.getElementById('btn-record');
    this.btnStop = document.getElementById('btn-stop');

    this.debugTxt = document.getElementById('debug-txt')

    this.recordingsCont = document.getElementById('recordings-cont')

    this.isRecording = false
    this.saveNextRecording = false

    this.debugTxt.innerHTML = "stopped"
  }

  init () {
    this._initEventListeners()
  }

  _initEventListeners () {

    this.btnRecord.addEventListener('click', evt => {
      this._stopAllRecording()
      this.saveNextRecording = true
      this._startRecording()

      this.btnRecord.disabled = true
      this.btnStop.disabled = false
      this.debugTxt.innerHTML = "recording"
    })

    this.btnStop.addEventListener('click', evt => {
      this._stopAllRecording();

      this.btnRecord.disabled = false
      this.btnStop.disabled = true
      this.debugTxt.innerHTML = "stopped"
    })
  }

  _startRecording () {
    if (!this.recorderSrvc) {
      this.recorderSrvc = new RecorderService()
      this.recorderSrvc.em.addEventListener('recording', (evt) => this._onNewRecording(evt))
    }

    if (!this.webAudioPeakMeter) {
      this.webAudioPeakMeter = new WebAudioPeakMeter()
      this.meterEl = document.getElementById('recording-meter')
    }

    this.recorderSrvc.onGraphSetupWithInputStream = (inputStreamNode) => {
      this.meterNodeRaw = this.webAudioPeakMeter.createMeterNode(inputStreamNode, this.recorderSrvc.audioCtx)
      this.webAudioPeakMeter.createMeter(this.meterEl, this.meterNodeRaw, {})
    }

    this.recorderSrvc.startRecording()
    this.isRecording = true
    this.debugTxt.innerHTML = "recording..."
  }

  _stopAllRecording () {
    if (this.recorderSrvc && this.isRecording) {

      this.recorderSrvc.stopRecording()
      this.isRecording = false

      if (this.meterNodeRaw) {
        this.meterNodeRaw.disconnect()
        this.meterNodeRaw = null
        this.meterEl.innerHTML = ''
      }
    }
  }

  _onNewRecording (evt) {
    if (!this.saveNextRecording) {
      return
    }
    const newIdx = this.recordingsCont.childNodes.length + 1

    const newEl = document.createElement('div')
    newEl.innerHTML = '<audio id="audio-recording-' + newIdx + '" controls></audio>'
    this.recordingsCont.appendChild(newEl)

    const recordingEl = document.getElementById("audio-recording-" + newIdx);
    recordingEl.src = evt.detail.recording.blobUrl
    recordingEl.type = evt.detail.recording.mimeType
  }
}
*/